<template>
  <div class="slot-bg">
    <h1 class="text-left ml-15 mt-2">Tukar Kado Sesi-1</h1>
    <slot-panel ref="slot-machine" />
  </div>
</template>

<script>
import SlotPanel from "../../components/SlotMachine/SlotPanel.vue";

export default {
  components: {
    SlotPanel,
  },
};
</script>

<style>
.slot-bg {
  /* background: url('../../assets/bg-slot2.jpg')
    no-repeat center center fixed !important;
  background-size: cover;
  height: 100%;
  overflow: hidden; */
}
</style>
